import { QUESTION_SETS, typeOfExamType } from '../../config/assessmentFamilies';

/** Questions of a (non-coding) set, keeping each row's index in the full saved list. */
export function questionsInSet(set, questions) {
  if (!set || set.coding) return [];
  return (questions || [])
    .map((q, idx) => ({ q, idx }))
    .filter(({ q }) => {
      const cat = q.exam_category || 'jd';
      if (cat !== set.category) return false;
      if (set.language) return (q.language || 'en') === set.language;
      return true;
    });
}

export function setCount(set, questions, codingQuestions) {
  return set.coding ? (codingQuestions?.length || 0) : questionsInSet(set, questions).length;
}

/** Sets shown in the rail: all, except `onlyWhenPresent` sets with no questions. */
export function visibleSets(questions, codingQuestions) {
  return QUESTION_SETS.filter((s) => !s.onlyWhenPresent || setCount(s, questions, codingQuestions) > 0);
}

/** Exam sets that draw questions from a question set. */
export function examSetsUsingSet(set, examSets) {
  return (examSets || []).filter((es) => {
    const sets = typeOfExamType(es.exam_type).sets;
    // Language exams draw from every proficiency language (exam_category "english").
    return sets.includes(set.id) || (set.category === 'english' && sets.includes('eng'));
  });
}
